import React from 'react';
import ReportViewer from "./base/ReportViewer";

const AchalandagePostesEnregistrements = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"AchalandagePostesEnregistrements"}/>
        </div>
    );
}
export default AchalandagePostesEnregistrements;